import { create } from 'zustand'
import { setAutoFreeze } from 'immer'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'
import { isDevtoolsEnabled } from 'src/store/utils/isDevtoolsEnabled'
import type { DailyStreak, DailyStreakStep, TimeWindow } from './types/domain'

setAutoFreeze(false)

interface DailyCheckInState {
  data?: DailyStreak
}

export interface DailyCheckInActions {
  setDailyCheckInData: (data: DailyStreak) => void
  clearDailyCheckInData: () => void
}

type DailyCheckInStore = DailyCheckInState & {
  actions: DailyCheckInActions
}

export const useDailyCheckInStore = create<DailyCheckInStore>()(
  devtools(
    immer((set) => ({
      data: undefined,
      actions: {
        setDailyCheckInData: (data) => {
          set(
            (state) => {
              state.data = data
            },
            undefined,
            'setDailyCheckInData'
          )
        },
        clearDailyCheckInData: () => {
          set(
            (state) => {
              state.data = undefined
            },
            undefined,
            'clearDailyCheckInData'
          )
        }
      }
    })),
    { name: 'DailyCheckInStore', enabled: isDevtoolsEnabled() }
  )
)

export const useDailyCheckInActions = () => useDailyCheckInStore((state) => state.actions)

export const useGetCurrentCheckInStep = () =>
  useDailyCheckInStore((state) => state.data?.currentStep ?? 0)

export const useGetCheckInSteps = (): DailyStreakStep[] =>
  useDailyCheckInStore((state) => state.data?.steps ?? [])

export const useGetNextLoginWindow = (): TimeWindow | undefined =>
  useDailyCheckInStore((state) => state.data?.nextLoginWindow)

export const useGetNextBetWindow = (): TimeWindow | undefined =>
  useDailyCheckInStore((state) => state.data?.nextBetWindow)
